import * as React from "react"
const LeaveIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    viewBox="0 0 512 512"
    {...props}
  >
    <path
      fill="#fff"
      d="M304.3 240.6c10-8.8 22.4-13.6 34.9-13.6 25.4 0 44.6 19.5 44.6 45.4v11.3h25.8v-133c0-28.4-23-51.6-51.2-51.6-.1 6.9-5.8 12.6-12.8 12.6h-12.8v23c0 7-5.8 12.8-12.8 12.8s-12.8-5.8-12.8-12.8V99h-25.6V60.8c0-14.1-11.5-25.6-25.6-25.6H153.6c-14.1 0-25.6 11.5-25.6 25.6V99h-25.6v35.8c0 7-5.8 12.8-12.8 12.8s-12.8-5.8-12.8-12.8v-23H64c-7 0-12.6-5.7-12.8-12.6C23 99.2 0 122.4 0 150.8v204c0 28.4 23 51.6 51.2 51.6h159.3c-11.7-11.1-18.5-26.1-18.5-41.7 0-16.5 7.4-32.3 20.2-43.6zM153.6 99V60.8H256V99zM512 346.2v36.9c0 20.3-16.6 36.9-36.9 36.9H358.2v37c0 20.3-21.8 26-37.1 12.6l-92-80.6c-15.3-13.4-15.3-35.2 0-48.6l92.1-80.6c15.3-13.4 37.1-7.7 37.1 12.6v36.9h116.9c20.2 0 36.8 16.6 36.8 36.9z"
      data-original-color="#000000ff"
    />
  </svg>
)
export default LeaveIcon
